import Layout from "@/components/Layout";
import NewsCard from "@/components/NewsCard";
import NewsCardSkeleton from "@/components/NewsCardSkeleton";
import SchemaBreadcrumb from "@/components/SchemaBreadcrumb";
import SEOHead from "@/components/SEOHead";
import { useNews } from "@/hooks/use-news";

const Noticias = () => {
	const { data: news = [], isLoading, error } = useNews();

	return (
		<Layout>
			<SEOHead
				title="Notícias sobre o Cadastro Imobiliário Brasileiro | Portal CIB"
				description="Últimas notícias sobre o Cadastro Imobiliário Brasileiro (CIB): regulamentações, prazos, decisões e impactos para cartórios, corretores e proprietários."
				canonicalUrl="/noticias"
				keywords="notícias CIB, cadastro imobiliário brasileiro, regulamentação imobiliária, cartório de imóveis, SINTER, mercado imobiliário, atualizações CIB"
			/>
			<SchemaBreadcrumb />

			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
				<div className="mb-12 text-center space-y-6">
					<h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight animate-slide-down">
						Notícias sobre o Cadastro Imobiliário Brasileiro
					</h1>
					<p className="text-lg text-muted-foreground max-w-3xl mx-auto leading-relaxed animate-slide-up stagger-1">
						Acompanhe as últimas novidades sobre o Cadastro Imobiliário
						Brasileiro, regulamentações e impactos no mercado imobiliário.
					</p>
				</div>

				<section id="noticias" className="py-12">
					<div className="flex items-center justify-between mb-12 animate-slide-up">
						<h2 className="text-2xl md:text-3xl font-bold tracking-tight">
							Todas as publicações
						</h2>
					</div>

					{isLoading && (
						<div
							className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
							role="status"
							aria-label="Carregando notícias"
						>
							{[0, 1, 2, 3, 4, 5].map((i) => (
								<NewsCardSkeleton key={i} />
							))}
						</div>
					)}

					{error && (
						<div className="text-center py-20">
							<p className="text-destructive">
								Não foi possível carregar as notícias. Tente novamente mais
								tarde.
							</p>
						</div>
					)}

					{!isLoading && !error && (
						<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
							{news.map((item, index) => (
								<div
									key={item.id}
									className={`animate-slide-up stagger-${Math.min(index + 1, 6)}`}
								>
									<NewsCard news={item} />
								</div>
							))}
						</div>
					)}

					{!isLoading && !error && news.length === 0 && (
						<div className="text-center py-20">
							<p className="text-muted-foreground">
								Nenhuma notícia disponível no momento.
							</p>
						</div>
					)}
				</section>
			</div>
		</Layout>
	);
};

export default Noticias;
